import Controls from "../components/Controls";
import RoomPage from "../components/RoomPage";

export default function MirrorRoomPage() {
  return <RoomPage roomId="mirror" slug="tukorterem" heroClassName="mirror-room-hero" navigation={<Controls backTo="/talalo" nextTo="/tukorterem/vetites" />} />;
}
